import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllMstEmployeeTypeSlice = createSlice({
    name: "getAllMstEmployeeType",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllMstEmployeeTypeSlice_actions = getAllMstEmployeeTypeSlice.actions;
export var fetchData = _getAllMstEmployeeTypeSlice_actions.fetchData, fetchDataSuccess = _getAllMstEmployeeTypeSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstEmployeeTypeSlice_actions.fetchDataFailure, resetState = _getAllMstEmployeeTypeSlice_actions.resetState;
export default getAllMstEmployeeTypeSlice.reducer;
